import { Icons } from '@cockpitai/components/atoms'

import { Typography } from '@cockpitai/components/atoms/Typography'
import { useChatStore } from '@cockpitai/store/chat'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { HistoryInput } from './HistoryInput'
import { SectionList } from './SectionList'
import { useHistoryChat } from './useHistoryChat'
import { sendAnalyticsEvent } from '@cockpitai/utils/analytics'

export function HistoryChat() {
  const { sections, setSearch, isLoading, handleSelectMessage } =
    useHistoryChat()

  const { setChatId } = useChatStore()

  const handleHistoryOpen = () => {
    sendAnalyticsEvent('chat_history_header_open')
  }

  return (
    <Popover>
      <PopoverButton
        autoFocus={false}
        onClick={handleHistoryOpen}
        className="h-full rounded-l-none rounded-r-lg border-transparent bg-gray-850 px-4 outline-none hover:bg-gray-500">
        <Icons.Down style={{ width: '7px' }} className="text-white" />
      </PopoverButton>
      <PopoverPanel
        transition
        anchor="bottom end"
        className="!max-h-96 w-80 origin-top-right space-y-3 rounded-xl border border-none bg-solid py-2 text-white transition duration-100 ease-out [--anchor-gap:25px] data-[closed]:scale-95 data-[closed]:opacity-0 focus:outline-none">
        {({ close, open }) => (
          <div className="relative flex pt-12">
            <HistoryInput
              isChat
              isLoading={isLoading}
              onSearch={setSearch}
              isOpen={open}
            />
            {sections.length > 0 ? (
              <div className="custom-scrollbar h-80 w-full">
                {sections.map((section) => (
                  <SectionList
                    key={section.title}
                    title={section.title}
                    items={section.items}
                    onClick={(historyChatId) => {
                      handleSelectMessage(historyChatId)

                      setChatId(historyChatId)

                      sendAnalyticsEvent('chat_history_header_select', {
                        chat_id: historyChatId,
                        chat_date: section.title,
                        chat_title: sections.find(section =>
                          section.items.some(item => item.id === historyChatId)
                        )?.items.find(item => item.id === historyChatId)?.title
                      })

                      close()
                    }}
                  />
                ))}
              </div>
            ) : (
              <div className="w-full py-4 text-center">
                <Typography
                  type="bodyOne"
                  weight="medium"
                  className="px-2 text-white/50">
                  Nenhuma conversa encontrada
                </Typography>
              </div>
            )}
          </div>
        )}
      </PopoverPanel>
    </Popover>
  )
}
